import { HsmTemplate } from '../../types';
import { Badge } from '../ui/badge';
import React from 'react';

/**
 * Badge configuration for template status
 */
export const TEMPLATE_STATUS_CONFIG: Record<
  string,
  { variant: 'approved' | 'pending' | 'rejected' | 'secondary'; label: string }
> = {
  APPROVED: { variant: 'approved', label: 'Aprovado' },
  PENDING: { variant: 'pending', label: 'Pendente' },
  REJECTED: { variant: 'rejected', label: 'Rejeitado' },
  DISABLED: { variant: 'secondary', label: 'Desativado' },
  IN_APPEAL: { variant: 'pending', label: 'Em Recurso' },
  PENDING_DELETION: { variant: 'secondary', label: 'Excluindo' },
  DELETED: { variant: 'secondary', label: 'Excluido' },
  LIMIT_EXCEEDED: { variant: 'rejected', label: 'Limite Excedido' },
};

/**
 * Returns a Badge element for a template status
 */
export function getTemplateStatusBadge(status: string): React.ReactElement {
  const config = TEMPLATE_STATUS_CONFIG[status] || {
    variant: 'secondary' as const,
    label: status,
  };
  return React.createElement(Badge, { variant: config.variant }, config.label);
}

/**
 * Extracts the body text from a template's components
 */
export function getTemplateBodyText(template: HsmTemplate): string {
  const bodyComponent = template.components?.find((c) => c.type === 'BODY');
  return bodyComponent?.text || '';
}

/**
 * Extracts numbered parameters (e.g., "1", "2") from template body text
 */
export function getTemplateParameters(template: HsmTemplate): string[] {
  const bodyText = getTemplateBodyText(template);
  const matches = bodyText.match(/\{\{(\d+)\}\}/g) || [];
  return matches.map((m) => m.replace(/\{\{|\}\}/g, ''));
}
